import type { PbxLocationsLocale } from './en'

export const pbxLocationsNe = {
  header: `स्थानहरू`,
  headerSubtext: `यस पीबीएक्समा कार्यालय स्थानहरू व्यवस्थापन गर्नुहोस्। प्रत्येक स्थान एउटा E911 फोन नम्बरसँग जोडिन्छ जुन आपतकालीन कलहरूको कलर ID को रूपमा प्रयोग हुनेछ।`,
  addLocation: `स्थान थप्नुहोस्`,
  searchPlaceholder: `स्थानहरू खोज्नुहोस्`,
  empty: `यस पीबीएक्सका लागि हालसम्म कुनै स्थान कन्फिगर गरिएको छैन।`,
  loadError: `स्थानहरू लोड गर्न सकिएन।`,
  column: {
    name: `नाम`,
    extensionCount: `एक्सटेन्सनहरू`,
    e911Number: `E911 नम्बर`,
    e911Address: `E911 ठेगाना`,
    actions: `कार्यहरू`,
  },
  notConfigured: `कन्फिगर गरिएको छैन`,
  notConfiguredE911Number: `कुनै E911 नम्बर तोकिएको छैन`,
  notConfiguredE911Address: `कुनै E911 ठेगाना दर्ता छैन`,
  edit: `सम्पादन गर्नुहोस्`,
  delete: `मेटाउनुहोस्`,
  extensionCountLabel_one: `{{count}} एक्सटेन्सन`,
  extensionCountLabel_other: `{{count}} एक्सटेन्सनहरू`,
  form: {
    createHeader: `स्थान थप्नुहोस्`,
    editHeader: `स्थान सम्पादन गर्नुहोस्`,
    nameLabel: `नाम`,
    namePlaceholder: `e.g. Main Office`,
    nameRequired: `नाम आवश्यक छ`,
    phoneNumberLabel: `E911 फोन नम्बर`,
    phoneNumberPlaceholder: `फोन नम्बर चयन गर्नुहोस्`,
    phoneNumberHelp: `यस स्थानबाट गरिने आपतकालीन कलहरूका लागि यस नम्बरको E911 ठेगाना प्रयोग हुनेछ।`,
    noAvailableNumbers: `तोक्नका लागि कुनै फोन नम्बर उपलब्ध छैन।`,
    loadingAvailableNumbers: `उपलब्ध नम्बरहरू लोड हुँदैछ...`,
    cancel: `रद्द गर्नुहोस्`,
    save: `सेभ गर्नुहोस्`,
    create: `स्थान सिर्जना गर्नुहोस्`,
    update: `स्थान अपडेट गर्नुहोस्`,
    createSuccess: `स्थान सिर्जना गरियो।`,
    updateSuccess: `स्थान अपडेट गरियो।`,
    createError: `स्थान सिर्जना गर्न सकिएन।`,
    updateError: `स्थान अपडेट गर्न सकिएन।`,
  },
  deleteModal: {
    header: `स्थान मेटाउनुहोस्`,
    confirmMessage: `के तपाईं "{{name}}" मेटाउन निश्चित हुनुहुन्छ? यो कार्य पूर्ववत गर्न सकिँदैन।`,
    reassignPrompt_one: `{{count}} एक्सटेन्सन यस स्थानमा तोकिएको छ र मेटाउनु अघि पुनः तोक्नुपर्छ। नयाँ स्थान छान्नुहोस्:`,
    reassignPrompt_other: `{{count}} एक्सटेन्सनहरू यस स्थानमा तोकिएका छन् र मेटाउनु अघि पुनः तोक्नुपर्छ। नयाँ स्थान छान्नुहोस्:`,
    reassignSelectPlaceholder: `गन्तव्य स्थान चयन गर्नुहोस्`,
    noOtherLocations: `यस पीबीएक्समा अरू कुनै स्थान छैन। पहिले अर्को स्थान सिर्जना गर्नुहोस्।`,
    cancel: `रद्द गर्नुहोस्`,
    confirm: `मेटाउनुहोस्`,
    confirmReassign: `पुनः तोकेर मेटाउनुहोस्`,
    success: `स्थान मेटाइयो।`,
    error: `स्थान मेटाउन सकिएन।`,
  },
} satisfies PbxLocationsLocale
